import { useMemo } from 'react'
import { useDataFormat } from 'Simple/Data.js'

import { startOfMonth, parseISO } from 'date-fns'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let from = useDataFormat({
    context: 'report',
    path: 'filter_values.transactions_start_date',
    viewPath: props.viewPath,
    format: item =>
      typeof item === 'string' ? parseISO(item) : startOfMonth(new Date()),
  })
  let to = useDataFormat({
    context: 'report',
    path: 'filter_values.transactions_end_date',
    viewPath: props.viewPath,
    format: item => (typeof item === 'string' ? parseISO(item) : new Date()),
  })

  return useMemo(() => {
    if (!data) return data
    return { ...data, from, to }
  }, [])
}
